import View from './PersonalInfoWorkflowView';

export default View;
